<template>
    <modal name="userAccountModal" :width="600" height="auto" :adaptive="true" :scrollable="true">
        <div class="p-0 overflow-hidden rounded-lg bg-white">
            <!-- Header -->
            <div class="bg-gray-50 px-4 py-3 border-bottom border-light d-flex justify-content-between align-items-center">
                <h4 class="text-gray-800 font-weight-bold m-0">{{ isEdit ? 'Editar Cuenta' : 'Nueva Cuenta' }}</h4>
                <button type="button" class="close text-gray-500" @click="$modal.hide('userAccountModal')" style="outline:none; opacity: 0.6; transition: opacity 0.2s;">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            
            <!-- Body -->
            <div class="p-4">
                <form @submit.prevent="save">
                    <div class="form-group mb-4">
                        <label class="text-xs font-weight-bold text-uppercase text-gray-500 mb-2">Nombre de la cuenta</label>
                        <input type="text" v-model="form.name" class="form-control form-control-lg bg-light border-0 rounded-lg text-dark" placeholder="Ej. Gmail Corporativo" required>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group mb-4">
                                <label class="text-xs font-weight-bold text-uppercase text-gray-500 mb-2">Link de Acceso</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text border-0 bg-light text-muted rounded-left-lg"><i class="fas fa-link"></i></span>
                                    </div>
                                    <input type="text" v-model="form.access_link" class="form-control bg-light border-0 rounded-right-lg text-dark" placeholder="https://...">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-4">
                                <label class="text-xs font-weight-bold text-uppercase text-gray-500 mb-2">Identificador</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text border-0 bg-light text-muted rounded-left-lg"><i class="fas fa-user"></i></span>
                                    </div>
                                    <input type="text" v-model="form.identifier" class="form-control bg-light border-0 rounded-right-lg text-dark" placeholder="Usuario / Email">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group mb-4">
                        <label class="text-xs font-weight-bold text-uppercase text-gray-500 mb-2">Contraseña</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text border-0 bg-light text-muted rounded-left-lg"><i class="fas fa-lock"></i></span>
                            </div>
                            <input :type="showPassword ? 'text' : 'password'" v-model="form.password" class="form-control bg-light border-0 text-dark" placeholder="••••••••">
                            <div class="input-group-append">
                                <button class="btn btn-light border-0 text-muted rounded-right-lg hover-bg-gray-200" type="button" @click="showPassword = !showPassword">
                                    <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="form-group mb-4">
                        <label class="text-xs font-weight-bold text-uppercase text-gray-500 mb-2">Descripción (Opcional)</label>
                        <textarea v-model="form.description" class="form-control bg-light border-0 rounded-lg text-dark" rows="3" placeholder="Detalles adicionales..."></textarea>
                    </div>

                    <div class="d-flex justify-content-end pt-2 border-top border-light mt-2">
                        <button type="button" class="btn btn-light text-gray-600 font-weight-bold mr-3 px-4 rounded-lg hover-bg-gray-200" @click="$modal.hide('userAccountModal')">Cancelar</button>
                        <button type="submit" class="btn btn-teal font-weight-bold px-4 shadow-sm rounded-lg">
                            <i class="fas fa-save mr-2"></i> Guardar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </modal>
</template>

<script>
import request from '@/services/request';

export default {
    props: ['userId'],
    data() {
        return {
            form: {
                id: null,
                name: '',
                description: '',
                access_link: '',
                identifier: '',
                password: ''
            },
            isEdit: false,
            showPassword: false
        };
    },
    methods: {
        open(account = null) {
            if (account) {
                this.isEdit = true;
                this.form = { ...account };
            } else {
                this.isEdit = false;
                this.form = {
                    id: null,
                    name: '',
                    description: '',
                    access_link: '',
                    identifier: '',
                    password: ''
                };
            }
            this.showPassword = false;
            this.$modal.show('userAccountModal');
        },
        async save() {
            try {
                const payload = { ...this.form, user_id: this.userId };
                if (this.isEdit) {
                    await request.put(`/user_accounts/${this.form.id}`, payload);
                } else {
                    await request.post('/user_accounts', payload);
                }
                this.$emit('saved');
                this.$modal.hide('userAccountModal');
                this.$swal({
                    icon: 'success',
                    title: 'Guardado',
                    text: 'La cuenta ha sido guardada correctamente.',
                    timer: 2000,
                    showConfirmButton: false
                });
            } catch (error) {
                console.error(error);
                this.$swal({
                    icon: 'error',
                    title: 'Error',
                    text: 'Hubo un error al guardar la cuenta.',
                });
            }
        }
    }
};
</script>

<style scoped>
.bg-gray-50 { background-color: #f9fafb; }
.bg-white { background-color: #ffffff; }
.text-gray-800 { color: #1f2937; }
.text-gray-600 { color: #4b5563; }
.text-gray-500 { color: #6b7280; }
.text-dark { color: #111827; }
.border-light { border-color: #e5e7eb !important; }

.text-xs { font-size: 0.75rem; }

.btn-teal {
    background-color: #0f766e;
    color: white;
    border: none;
    transition: all 0.2s;
}
.btn-teal:hover {
    background-color: #0d6e66;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px -1px rgba(15, 118, 110, 0.2), 0 2px 4px -1px rgba(15, 118, 110, 0.1);
}

.hover-bg-gray-200:hover {
    background-color: #e5e7eb;
}

.close:hover {
    opacity: 1 !important;
}

/* Rounded corners helpers */
.rounded-lg { border-radius: 0.5rem !important; }
.rounded-left-lg { border-top-left-radius: 0.5rem !important; border-bottom-left-radius: 0.5rem !important; }
.rounded-right-lg { border-top-right-radius: 0.5rem !important; border-bottom-right-radius: 0.5rem !important; }

/* Input focus override */
.form-control:focus {
    box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.15); /* Teal shadow */
    background-color: #fff !important;
}
</style>
